<!--

    * UBCO Header and Global Search *
    This is a UBCO Header that gets its styles and scripts from the UBC CDN.
    ! DO NOT ADD ANY STYLES OR SCRIPTS, IT'S ALL HANDLED BY THE UBC CDN SCRIPT AND STYLESHEETS !

-->

<!-- UBC Global Utility Menu -->
<div class="collapse expand" id="ubc7-global-menu">
    <div id="ubc7-search" class="expand">
        <div class="container">
            <div id="ubc7-search-box">
                <form class="form-search" method="get" action="http://www.ubc.ca/search/refine/" role="search">
                    <input type="text" name="q" placeholder="Search this website" class="input-xlarge search-query">
                        <input type="hidden" name="label" value="Search Life Cycle Management Laboratory" />
                    <input type="hidden" name="site" value="*.lcml.engineering.ok.ubc.ca" />
                    <button type="submit" class="btn">Search</button>
                </form>
            </div>
        </div>
    </div>
    <div class="container">
        <div id="ubc7-global-header" class="expand">
            <!-- Global Utility Header from CDN -->
        </div>
    </div>
</div>
<!-- End of UBC Global Utility Menu -->
<!-- UBC Header -->
<header id="ubc7-header" class="row-fluid expand">
    <div class="container">
        <div class="span1">
            <div id="ubc7-logo">
                <a href="http://www.ubc.ca">The University of British Columbia</a>
            </div>
        </div>
        <div class="span2">
            <div id="ubc7-apom">
                <a href="http://cdn.ubc.ca/clf/ref/aplaceofmind">UBC - A Place of Mind</a>                        
            </div>
        </div>
        <div class="span9" id="ubc7-wordmark-block">
            <div id="ubc7-wordmark">
                <a href="http://www.ubc.ca/okanagan">The University of British Columbia</a>
                <span class="ubc7-campus" id="ubc7-okanagan-campus">Okanagan Campus</span>
            </div>
            <div id="ubc7-global-utility">
                <button type="button" data-toggle="collapse" data-target="#ubc7-global-menu"><span>UBC Search</span></button>
                <noscript><a id="ubc7-global-utility-no-script" href="http://www.ubc.ca/">UBC Search</a></noscript>
            </div>
        </div>
    </div>
</header>
<!-- End of UBC Header -->
<!-- UBC Unit Identifier -->
<div id="ubc7-unit" class="row-fluid expand unit-identifier-override">
    <div class="container">
        <div class="span12">
            <!-- Mobile Menu Icon -->
            <div class="navbar">
                <!-- svelte-ignore a11y-missing-attribute -->
                <a class="btn btn-navbar" data-toggle="collapse" data-target="#ubc7-unit-navigation">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </a>
            </div>
            <!-- Read more about Unit Name Treatment on http://brand.ubc.ca/clf -->
            <!-- No Faculty Treatment -->
            <div id="ubc7-unit-name" class="ubc7-single-element"> 
            <div id="ubc7-unit-name">
                <a href="/"><span id="ubc7-unit-faculty">Faculty Name</span><span id="ubc7-unit-identifier" class="faculty-name-override">Life Cycle Management Laboratory</span></a>					
            </div>
            </div>
        </div>
    </div>
</div>
<!-- End of UBC Unit Identifier -->

<style lang="sass">
    .unit-identifier-override
        box-shadow: inset 0px 3px 6px rgba(0, 0, 0, 0.2) !important
        background-color: #23455E

        .faculty-name-override
            text-transform: uppercase
            text-shadow: none !important
</style>